import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ConnectedWalletInfo } from './ConnectWalletInfo';
import { useWalletInfo } from '../hooks/useWalletInfo';

import { SelectNetwork } from '@/components/SelectNetwork';
import { useOpenConnectWalletModal } from '@/shared/hooks/useOpenConnectWalletModal';
import { LoggedInProvider } from '@/app/providers';
import { reconnectIfWalletAvailableSaga } from '@/shared/store/wallets/actions';
import { Button, ButtonVariant } from '@/shared/ui';
import { useAuthStatus } from '@/shared/hooks/useAuthStatus';
import { getMeAction } from '@/shared/store/organization/actions';
import { AuthButton } from '@/features/AuthButton';

interface ConnectWalletProps {
    handleSetBannerState: (value: boolean) => void;
}

export const ConnectWallet: React.FC<ConnectWalletProps> = ({ handleSetBannerState }) => {
    const dispatch = useDispatch();
    const { wallet } = useWalletInfo();
    const { isLoggedIn } = useAuthStatus();
    const handleConnectWalletClick = useOpenConnectWalletModal();

    useEffect(() => {
        if (isLoggedIn) {
            dispatch(reconnectIfWalletAvailableSaga());
        }
    }, [isLoggedIn, dispatch]);

    useEffect(() => {
        dispatch(getMeAction());
    }, []);

    return (
        <div className='flex justify-between gap-3'>
            <div className='h-[44px] flex flex-row justify-center items-center rounded'>
                {wallet && (
                    <LoggedInProvider
                        haveAuth={<SelectNetwork handleShowBanner={handleSetBannerState} />}
                    />
                )}
            </div>
            <div className='h-[44px] flex flex-row justify-center items-center rounded'>
                {wallet && <LoggedInProvider haveAuth={<ConnectedWalletInfo />} />}
            </div>

            {!wallet && (
                <div className='h-[44px] flex flex-row justify-center items-center rounded'>
                    <LoggedInProvider
                        haveAuth={
                            <Button
                                variant={ButtonVariant.Secondary}
                                onClick={handleConnectWalletClick}
                                name='connect-wallet'
                                className='flex justify-center items-center w-[152px] text-md h-[44px] bg-background-secondary hover:bg-transparent'
                            >
                                Connect Wallet
                            </Button>
                        }
                    />
                </div>
            )}
            <AuthButton />
        </div>
    );
};
